<template>
    <div :class="$common.getClassName('server-componesnts-content')">
        <div :class="$common.getClassName('server-select-box')" v-if="$pageLoadedDone">
            <div :class="$common.getClassName('title')" @click="onServerUpandDown()">
                <div :class="$common.getClassName('title-l')" ><i>1</i><span v-html="$t('remittance_bills_server')"></span></div>
                <div :class="$common.getClassName('title-r')" v-if="selectedUserData">
                    <span :class="$common.getClassName('title-server')">S{{selectedServerData['server_sid']}}: {{selectedServerData['server_name']}}</span>
                    <span :class="$common.getClassName('title-user-info')">{{decodeURI(selectedUserData.name)}}<i></i></span>
                    <span :class="$common.getClassName('title-app-logo')"><img v-if="app_logo" :src="app_logo" alt="logo"></span>
                </div>
                <div :class="`${$common.getClassName('title-icon')} ${upandDown ? 'down': 'up'}`"></div>
            </div>
            <div :class="`${$common.getClassName('server-content')}  ${upandDown ? 'show': 'hide'}`">
                <div :class="$common.getClassName('server-select')">
                    <select v-model="vueSelectedServerValue" @change="onChangeServerToUser(vueSelectedServerValue)">
                        <option v-for="item in serverList" :value="item['server_sid']">S{{item['server_sid']}}: {{item['server_name']}}</option>
                    </select>
                </div>
                <div :class="$common.getClassName('server-user-info')">
                    <a v-for="(item, index) in userInfo"
                       @click="onChangeSelectUser(index,item)"
                       :class="index === selectedUserValue ? 'active':''"
                       href="javascript:void(0)"><span v-html="decodeURI(item.name)"></span></a>
                </div>
                <div :class="$common.getClassName('server-tips')" v-if="userInfo.length === 0" v-html="$t('select_user_not_user_tip')"></div>
                <div :class="$common.getClassName('app-logo')"><img v-if="app_logo" :src="app_logo" alt="logo"></div>
            </div>
            <div class="clear"></div>
        </div>

    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters, mapMutations} from 'vuex';

    export default {
        name : 'server1',
        data() {
            return {
                vueSelectedServerValue : this.selectedServerId,
                upandDown : true,
                timeer: null,
                cssName: 'show'
            };
        },

        computed: {
            ...mapState(['$pageLoadedDone','$pageLoadAjaxDone','$common']),
            ...mapState('Module_Access', ['userAccessStatus']),
            ...mapState('Module_User', ['userInfo','selectedUserValue','selectedUserData']),
            ...mapState('Module_Server', ['serverList','selectedServerId','selectedServerData']),
            ...mapState('Module_Logo', ['app_logo']),
        },
        watch:{
            userAccessStatus:function(val){
                if(val === true) {
                    this.GET_SERVER_LIST();
                }
            },
            selectedServerId(){
                this.vueSelectedServerValue = this.selectedServerId
                this.GET_USER_INFO();
            },
            selectedUserData(){
               this.upandDown = !this.selectedUserData ? true : false;
            }
        },
        methods:{

            decodeURI(str){
                return decodeURIComponent(str);
            },

            onServerUpandDown(){
                if(!this.selectedUserData) return;
                this.upandDown = !this.upandDown;
            },

            /**
             * 选择服务器联动获取该用户列表
             * @param selected
             */
            onChangeServerToUser(selected){
                this.GET_USER_INFO(selected);
                this.CLICK_SELECTED_SERVER_DATA(selected);
            },

            /**
             * 改变选择用户角色信息
             * @param selected
             * @param userinfo
             */
            onChangeSelectUser(selected, userinfo){
                this.CLICK_SELECTED_USER_STATUS({
                    selected: selected,
                    data: userinfo
                })
            },

            ...mapActions('Module_User', ['GET_USER_INFO','CLICK_SELECTED_USER_STATUS']),
            ...mapActions('Module_Server', ['GET_SERVER_LIST','CLICK_SELECTED_SERVER_DATA']),
        }
    };
</script>

<style type="scss">
</style>



// WEBPACK FOOTER //
// website/components/servers/Server1.vue